export default __webpack_public_path__ + "static/media/anambra_about.b2cb923f.jpg";